// extracted by mini-css-extract-plugin
export default {"IconText":"IconText_IconText__yohgT","center":"IconText_center__BK929"};